import React, { useState, useEffect, useRef } from 'react';

import './postAd.css';
import { useNavigate, Link } from "react-router";
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Button from 'react-bootstrap/Button';
import Alert from 'react-bootstrap/Alert';

import Pagination from 'react-bootstrap/Pagination';

import { IoLayersOutline } from "react-icons/io5";
import { IoCheckmarkSharp } from "react-icons/io5";

import { HiOutlineArrowLongRight } from "react-icons/hi2";


import Form from 'react-bootstrap/Form';
import Swal from 'sweetalert2'



import Header from '../../components/header/header';
import Footer from '../../components/footer/footer';
import AccountSidebar from '../../components/sidebar/accountSidebar';
import MultiImageUpload from '../../components/upload/multipleImageUpload'

import {connect} from 'react-redux';
import * as actions from '../../store/propertyType/actions';
import * as locationActions from '../../store/location/actions';
import * as postDataActions from '../../store/postData/actions';



let active = 2;
let items = [];
for (let number = 1; number <= 5; number++) {
  items.push(
    <Pagination.Item key={number} active={number === active}>
      {number}
    </Pagination.Item>,
  );
}

const PostAd = ({ getPropertyTypes, propertyTypeWithAttributes, loggedIn, fetchLocations, suggestedLocation, setPostAdsStep1Data, validatePropertyTitle, postAdData }) => {  
    const navigate = useNavigate(); 
    const [propertyTypes, setPropertyTypes] = useState('');
    const [ propertyTypeSubCategory, setPropertyTypeSubCategory ] = useState('');
    const [inputValue, setInputValue] = useState('');
    const [ resultText, setResultText ] = useState('');
    const [ activeLocationId, setActiveLocationID ] = useState('');
    const titleRef = useRef(null);
    const [ formData, setFormData ] = useState({
        title: '',
        property_list_type: '',
        city: 'Jaipur',
        property_type_subcategory: '',
        property_type: '',
        location: '',

    });
    const [ propertyAttributes, setPropertyAttributes ] = useState('');
    const [ propertyAttributesValues, setPropertyAttributesValues ] = useState('');
    const [ errors, setErrors ] = useState({});
    const [ titleError, setTitleError ] = useState('');
    const [ uploadImages, setUploadImages ] = useState([]);
    const [ currentImages, setCurrentImages ] = useState('');
    // console.log('postAdData', postAdData)
    useEffect(() => {
		if(!loggedIn){
			window.location.href = '/login';
		}
	},[loggedIn]);

    useEffect(() => {
		loadData();
	},[]);

    useEffect(() => { 
        // console.log('hi', propertyTypes, postAdData)
        if(postAdData && postAdData.formData && postAdData.formData.property_type ){
            setFormData(postAdData.formData);
            if(postAdData.propertyImages && postAdData.propertyImages.length > 0){
                updateImages(postAdData.propertyImages);
            }
            if(postAdData.propertyAttributes){
                setPropertyAttributes(postAdData.propertyAttributes);
            }
            if(postAdData.propertyAttributesValues){
                setPropertyAttributesValues(postAdData.propertyAttributesValues);
            }
        }
    },[postAdData]);

    useEffect(() => {
		if(postAdData && postAdData.formData && postAdData.formData.property_type && propertyTypes){
            if(postAdData.formData.property_type == 'Residential'){
                setPropertyTypeSubCategory(propertyTypes['residential_properties'])
            } else if(postAdData.formData.property_type == 'Commercial'){
                setPropertyTypeSubCategory(propertyTypes['commercial_properties'])
            }
            setFormData(postAdData.formData);
            
        }
	},[propertyTypes]);

    useEffect(() => {
        if(propertyTypeWithAttributes){
		    setPropertyTypes(propertyTypeWithAttributes);
            
        }
	},[propertyTypeWithAttributes]);

    const loadData = async() => {
        await getPropertyTypes().then(res => {
            // console.log()
        })
    }

    // When Change Property type then change values of 
    const handlePropertyTypeChange = (event) => {
        const { name, value } = event.target;
        if(value == 'Residential'){
            setPropertyTypeSubCategory(propertyTypes['residential_properties'])
        } else if(value == 'Commercial'){
            setPropertyTypeSubCategory(propertyTypes['commercial_properties'])
        }
        
        setFormData({
            ...formData,
            [name]: value
        });
    }

    // When Click on Location and try to find out location
    const handleInputChange = (event) => {
        
        const { name, value } = event.target;
        setInputValue(value);
        setFormData({
            ...formData,
            [name]: value
        });
        
        // Fetch suggestions from the server when the input changes
        fetchLocations({searchTerm: value}).then(res => {
            if(value.length > 4 && res.payload.data && res.payload.data.length == 0){
                setResultText('No Results Found');
            } else {
                setResultText('');
            }
        });
    };

    const updateImages = (images) => {
        // console.log('parent', images)
        // setCurrentImages(images);
        setUploadImages((prevImages) => [...prevImages, ...images]);
        // console.log('mergeImage', mergeImage)
        // setUploadImages(mergeImage);
    }

    const handleChange = (event) => {
        
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: value
        });
        if(name == 'property_type_subcategory'){
            // console.log('hello', propertyTypeSubCategory)
            const matchedProperty = propertyTypeSubCategory.find(
                (property) => property.property_type_id === parseInt(value)
            );
            // console.log('matchedProperty', matchedProperty.attributes)
            setPropertyAttributes(matchedProperty.attributes);
            setPropertyAttributesValues(matchedProperty.attributes_values)
        }
    };

    const checkPropertyTitle = async(event) => {
        // if(formData.title.length>0){
        //     await validatePropertyTitle({title: formData.title}).then(res => {
        //         if(res.payload.response && res.payload.response.status == 422){
        //             console.log(res.payload.response.data.message.message)
        //             Swal.fire({
        //                 title: res.payload.response.statusText,
        //                 text: res.payload.response.data.message.message,
        //                 icon: 'error',
        //                 confirmButtonText: 'Ok'
        //               });
        //               titleRef.current.value = '';
        //               setFormData({
        //                 ...formData,
        //                 title: ''
        //             });
        //         } 
        //     })
        // }
    }

    const updateInputValue = (value) => {
        setInputValue(value);
        setFormData({
            ...formData,
            location: value
        });
    }

    const findFormErrors = () => {
        const { title, property_list_type, city, property_type_subcategory, property_type, location} = formData
        let newErrors = {}

        
        if ( !title || title== '' ) newErrors.title = 'Enter property title'
        if ( !property_list_type || property_list_type === '' ) newErrors.property_list_type = 'Authenticity cannot be blank!'
        if ( !city || city== '' ) newErrors.city = 'Enter City address'
        if ( !property_type_subcategory || property_type_subcategory === '' ) newErrors.property_type_subcategory = 'Select sub-category'
        if ( !property_type || property_type === '' ) newErrors.property_type = 'Select property type'
        if ( !location || location === '' ) newErrors.location = 'Enter pocation'
        
        // console.log('newErrors', newErrors)
        setErrors(newErrors);
        return newErrors
    }

    const handleSubmit = async (event) => { 
        const checkErrors = findFormErrors();
		// console.log('submit')
		const form = event.currentTarget;
        event.preventDefault();
        event.stopPropagation();
        // console.log('check 2', Object.keys(checkErrors).length)
        if ( Object.keys(checkErrors).length > 0 ) {
            // We got errors!
            setErrors(checkErrors);
            // console.log('check 3');
        } else {
            // save all data into reducers
            setPostAdsStep1Data({formData, propertyAttributes, propertyAttributesValues, locationId: activeLocationId, propertyImages: uploadImages});
            navigate(`/post-Ad/step2`);
        }
    }
    
    return (
        <div>
            <Header/>            

            <section className='pt-5 pb-5'>
                <Container>
                    <Row className='justify-content-center'>
                        <AccountSidebar />
                        <Col lg={9}>
                            <div className="card shadow">
                                <div>
                                    <ul className='d-flex flex-row process_tab w-100 m-0 p-0 justify-content-'>
                                        <li className='active'>
                                            <a href='#' className='d-flex align-items-center'>
                                                <i>
                                                    <span className='layer'><IoLayersOutline /></span>
                                                    <span className='check'><IoCheckmarkSharp /></span>
                                                </i>
                                                <div>
                                                    <div>Steps 01</div>
                                                    <p className='mb-0'>Ads Information</p>
                                                </div>
                                            </a>
                                        </li>
                                        <li>
                                            <a href='#' className='d-flex align-items-center'>
                                                <i>
                                                    <span className='layer'><IoLayersOutline /></span>
                                                    <span className='check'><IoCheckmarkSharp /></span>
                                                </i>
                                                <div>
                                                    <div>Steps 02</div>
                                                    <p className='mb-0'>Property Details </p>
                                                </div>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                <form className='p-4' onSubmit={handleSubmit}>
                                    {titleError && titleError != '' ? <Alert key='danger' variant='danger'>{titleError}</Alert>: '' }
                                    <Row className="mb-3">
                                        <Form.Group as={Col}  controlId="formGroupLocation">
                                            <Form.Label>Property Name</Form.Label>
                                            <Form.Control type="text" placeholder="Property Title" name="title" 
                                                onChange={handleChange} 
                                                onBlur={checkPropertyTitle} 
                                                ref={titleRef}
                                                defaultValue={postAdData && postAdData.formData && postAdData.formData.title ? postAdData.formData.title : ''}
                                                className={ errors.title ? "input-error mb-3" : "mb-3"}
                                            />
                                        </Form.Group>
                                        <Form.Group as={Col}  controlId="formGroupLocation">
                                            <Form.Label>Location</Form.Label>
                                            <div className='position-relative'>
                                            <Form.Control type="text" placeholder="Location" name="location" 
                                                value={inputValue ? inputValue : postAdData && postAdData.formData && postAdData.formData.location ? postAdData.formData.location : ''} 
                                                onChange={handleInputChange} 
                                                
                                                className={ errors.location ? "input-error mb-3" : "mb-3"}
                                            />
                                            { 
                                        suggestedLocation && suggestedLocation.length > 0 ?
                                            <div className="autocomplete-result">
                                                <ul>
                                                {
                                                    suggestedLocation.map((location, index) => {
                                                        return <li key={`top30Trendingside${index}`} className={activeLocationId == location.location_id ? 'active' : ''} onClick={() => setActiveLocationID(location.location_id)}>
                                                                    
                                                                    <div className="content">
                                                                        <div>
                                                                            <div className="track-name">
                                                                                <div className="text-2" dangerouslySetInnerHTML={{__html: location.location_name}} onClick={() => updateInputValue(location.location_name)}></div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                            </li>
                                                    })
                                                    
                                                }
                                                </ul>
                                            </div>
                                        : ''
                                        
                                    }
                                    </div>
                                        </Form.Group>
                                        
                                    </Row>
                                    <Row className="mb-3">
                                        {/* <Form.Group as={Col} controlId="formGridEmail">
                                            <Form.Label>Advertisement posted by:</Form.Label>
                                            <Form.Select aria-label="Default select example">
                                                <option>Open this select menu</option>
                                                <option value="1">One</option>
                                                <option value="2">Two</option>
                                                <option value="3">Three</option>
                                            </Form.Select>
                                        </Form.Group> */}
                                        <Form.Group as={Col} controlId="formGridEmail" >
                                            <Form.Label>Type of Property</Form.Label>
                                            <Form.Select aria-label="Default select example" className={ errors.property_type ? "input-error mb-3" : "mb-3"} onChange={handlePropertyTypeChange} name="property_type" defaultValue={postAdData && postAdData.formData && postAdData.formData.property_type  ? postAdData.formData.property_type : ''}>
                                                <option>Choose Property Type</option>
                                                <option value="Commercial" >Commercial Property</option>
                                                <option value="Residential" >Residential Property</option>
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group as={Col} controlId="formGridEmail">
                                            <Form.Label>Sub-Category</Form.Label>
                                            <Form.Select aria-label="Default select example" className={ errors.property_type_subcategory ? "input-error mb-3" : "mb-3"} name="property_type_subcategory" onChange={handleChange} defaultValue={postAdData && postAdData.formData && postAdData.formData.property_type_subcategory  ?   postAdData.formData.property_type_subcategory : ''}>
                                                <option>Choose</option>
                                                {
                                                    propertyTypeSubCategory ?
                                                        propertyTypeSubCategory.map((subcategory) => (
                                                        <option key={`subcategory${subcategory.property_type_id}`} value={subcategory.property_type_id} >
                                                            {subcategory.title}
                                                        </option>
                                                        ))
                                                    : ''
                                                }
                                            </Form.Select>
                                        </Form.Group>
                                        {/* <Form.Group as={Col} controlId="formGridPassword">
                                            <Form.Label>Authenticity</Form.Label>
                                            <Form.Check // prettier-ignore
                                                type="switch"
                                                id="custom-switch"
                                                label="Check this switch"
                                            />
                                        </Form.Group> */}
                                    </Row>
                                    <Row className="mb-3">
                                        <Form.Group as={Col} controlId="formGridEmail">
                                            <Form.Label>Authenticity</Form.Label>
                                            <Form.Select aria-label="Default select example" className={ errors.property_list_type ? "input-error mb-3" : "mb-3"} name="property_list_type" onChange={handleChange} defaultValue={postAdData && postAdData.formData && postAdData.formData.property_list_type  ? postAdData.formData.property_list_type : ''}>
                                                <option>Choose Property to be list in</option>
                                                <option value="rent" >Rent</option>
                                                <option value="sale" >Sale</option>
                                            </Form.Select>
                                        </Form.Group>
                                        <Form.Group as={Col}  controlId="formGroupCity">
                                            <Form.Label>City</Form.Label>
                                            <Form.Control type="email" placeholder="City" disabled name="city" defaultValue={'Jaipur'} onChange={handleChange} />
                                        </Form.Group>
                                    </Row>
                                    <Row>
                                        {/* {
                                            uploadImages && uploadImages.length > 0 ?
                                            <Col>
                                                <div className="uploaded-images">
                                                {
                                                    uploadImages.map((uploadedImage, index) => {
                                                        return <img src={`${config.uploadUrl}${uploadedImage}`} />
                                                    })
                                                }
                                               
                                                </div>
                                                
                                            </Col>
                                            : ''
                                        } */}
                                        <Col>
                                            <MultiImageUpload updateImages={updateImages} />
                                        </Col>
                                    </Row>
                                    <Row className="mb-3 mt-4">
                                        <div>
                                            <Button variant="light" size="lg">View posting rules</Button>
                                            <Button variant="info" type="submit" size="lg" className="ms-3" >Next Steps <HiOutlineArrowLongRight /></Button>
                                        </div>
                                    </Row>
                                </form>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </section>

            
            <Footer/>
        </div>
    )
}
function mapStateToProps(state) {
    return {
      propertyTypeWithAttributes: state.propertyType.propertyTypeWithAttributes,
      loggedIn: state.customer.loggedIn,
      suggestedLocation: state.location.suggestedLocation,
      postAdData: state.postData && state.postData.postAdData ? state.postData.postAdData : ''
    };
}
  
function mapDispatchToProps(dispatch) {
    return {
        getPropertyTypes: () => dispatch(actions.getPropertyTypes()),
        fetchLocations: (post) => dispatch(locationActions.getAutocompleteLocation(post)),
        setPostAdsStep1Data: (post) => dispatch(postDataActions.setPostAdsStep1Data(post)),
        validatePropertyTitle: (post) => dispatch(postDataActions.validatePropertyTitle(post))
    };
}
  
export default connect(mapStateToProps, mapDispatchToProps)(PostAd);

